import { render, staticRenderFns } from "./PageIns.vue?vue&type=template&id=60113c9a&scoped=true&"
import script from "./PageIns.vue?vue&type=script&lang=js&"
export * from "./PageIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60113c9a",
  null
  
)

export default component.exports